const vHeight = (filterRows) => {
    let returnHeight = 76 - (7 * filterRows)
    return returnHeight + "vh"
}

export default vHeight